import { getTheme, ThemeName } from '@payflip/ui';
import { ThemeName as ThemeNameV2 } from '@payflip/ui/v2';
import { QueryClient } from 'react-query';
import { DefaultTheme } from 'styled-components';
import { environment } from './environment';

const themeName = environment.THEME;
const darkThemeName = `${themeName}-dark`;

export const defaultThemeV2 = (themeName || 'payflip') as ThemeNameV2;

export const defaultTheme = (getTheme(themeName as ThemeName) ||
  getTheme('payflip' as ThemeName)) as DefaultTheme;

export const darkTheme = getTheme(darkThemeName as ThemeName);

export const queryClient = new QueryClient();
